import React from "react";
import "./HeroSection.css";
import { getBackdropUrl, getMovieRating, getMovieReleaseYear, getMovieTitle } from "../utils/movieUtils";
import Icon from "./Icon";

/** @typedef {import("../types").Movie} Movie */

/**
 * Muestra la información destacada de la película seleccionada. No conoce
 * nada sobre el trailer/modal: eso lo maneja TrailerModal por separado.
 * @param {{
 *   movie: Movie|null,
 *   hasTrailer: boolean,
 *   onPlayTrailer: () => void,
 *   onAddFavorite: () => void,
 *   onRemoveFavorite: () => void,
 *   isFavorite: boolean,
 * }} props
 */
export default function HeroSection({
  movie,
  hasTrailer,
  onPlayTrailer,
  onAddFavorite,
  onRemoveFavorite,
  isFavorite,
}) {
  if (!movie) {
    return (
      <section className="hero-placeholder glass-panel">
        <Icon name="search" size={26} />
        <p>No hay película seleccionada.</p>
        <span>Buscá un título o elegí una de la grilla para verla acá.</span>
      </section>
    );
  }

  const backgroundImage = getBackdropUrl(movie);
  const title = getMovieTitle(movie);
  const releaseYear = getMovieReleaseYear(movie);
  const rating = getMovieRating(movie);

  return (
    <section
      key={movie.id}
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-info">
          <span className="hero-tag">
            <Icon name="star" size={14} /> Selección destacada
          </span>
          <div className="hero-meta">
            {rating ? (
              <span className="hero-rating">
                <Icon name="star" size={13} />
                {rating}
              </span>
            ) : null}
            <span className="hero-year">{releaseYear}</span>
          </div>
          <h2>{title}</h2>
          <p className="hero-overview">{movie.overview || "Sin descripción disponible."}</p>
          <div className="hero-actions">
            <button
              className={`btn btn-primary hero-play ${hasTrailer ? "has-trailer" : ""}`}
              onClick={onPlayTrailer}
              type="button"
              disabled={!hasTrailer}
            >
              <Icon name="play" /> Ver trailer
            </button>
            <button
              className={`btn btn-favorite ${isFavorite ? "is-active" : ""}`}
              onClick={isFavorite ? onRemoveFavorite : onAddFavorite}
              type="button"
            >
              <Icon name={isFavorite ? "heartOff" : "heart"} />
              {isFavorite ? "Quitar de favoritos" : "Añadir a favoritos"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
